import React, { Component } from "react";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from '../../boot/config';



//https://fkhadra.github.io/react-toastify/


/*

USE:
	//import toast from '../components/Toast/Toast';

	toast('error', "message", params);
or
	toast('error', error);


TYPES:
	info
	success
	warning
	error
	default




*/

const DURATION = 4500;


const _defaultParams = {
	position: "bottom-right",
	autoClose: DURATION,
	hideProgressBar: true,
	closeOnClick: true,
	pauseOnHover: true,
	draggable: true
};


export class ToastDOM extends Component {
	render() {
		return (
			<div>
				<ToastContainer
					position="bottom-right"
					autoClose={DURATION}
					hideProgressBar
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnVisibilityChange
					draggable
					pauseOnHover
					transition={Slide}
				/>
			</div>
		);
	}
}

export default function showToast(type, message, params) {
	const _params = { ..._defaultParams, ...params };

	if(type === "error" && !config.showErrorToasts){
		return;
	}

	if (message instanceof Error) {
		const err = JSON.parse(message.message);
		if (err.modelState && err.modelState[""][0]) {
			message = err.modelState[""][0];
		} else if (message.message) {
			message = message.message;
		}else{
			message = "An error has occurred"
		}
	}

	toast[type || "default"](message, _params);
}



// WEBPACK FOOTER //
// ./src/components/Toast/Toast.js